/**
 * Functional Component: StructuralLayerInfo
 *
 * This component renders informational text about the structural layer function hierarchy.
 *
 * Props:
 * @param {Object} props - The properties passed to the component.
 *
 * Returns:
 * @returns {JSX.Element} A JSX element containing the informational text.
 */
export const StructuralLayerInfo = (props: any) => {
  return (
    <p className="mt-3">
      The table above represents the material layer function hierarchy of Walls, Floors, and Roofs from Revit. <strong>It is an informative table. Thus it cannot be edited.</strong>
    </p>
  );
};
